(function () {
  function loadVideo(item) {
    var video = item.querySelector('.how-it-works-video');
    if (!video || video.dataset.loaded === 'true') return;
    var src = video.dataset.src;
    if (!src) return;
    video.dataset.loaded = 'true';
    item.setAttribute('data-video-status', 'loading');
    video.addEventListener('loadeddata', function onLoaded() {
      item.setAttribute('data-video-status', 'loaded');
      item.setAttribute('data-video-loaded', 'true');
      video.removeEventListener('loadeddata', onLoaded);
      video.play().catch(function () {});
    });
    video.src = src;
    video.load();
  }

  function initHowItWorks(section) {
    if (section.dataset.hiwInit === 'true') return;
    section.dataset.hiwInit = 'true';

    var grid = section.querySelector('.video-grid');
    var items = Array.prototype.slice.call(section.querySelectorAll('.how-video-item'));
    var modal = document.getElementById(section.id + '-modal');
    var modalVideo = modal ? modal.querySelector('.hiw-modal-video') : null;
    var modalClose = modal ? modal.querySelector('.hiw-modal-close') : null;
    var modalBackdrop = modal ? modal.querySelector('.hiw-modal-backdrop') : null;

    function openModal(item) {
      if (!modal || !modalVideo) return;
      var video = item.querySelector('.how-it-works-video');
      var src = video ? (video.currentSrc || video.src || video.dataset.src) : null;
      if (!src) return;
      items.forEach(function (other) {
        var v = other.querySelector('.how-it-works-video');
        if (v) v.pause();
      });
      modalVideo.src = src;
      modalVideo.currentTime = 0;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      modalVideo.play().catch(function () {});
    }

    function closeModal() {
      if (!modal || !modalVideo) return;
      modal.hidden = true;
      document.body.style.overflow = '';
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.load();
    }

    if (modalClose) modalClose.addEventListener('click', closeModal);
    if (modalBackdrop) modalBackdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    var observer = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadVideo(entry.target);
          });
        }, { rootMargin: '200px' })
      : null;

    var dragged = false;

    items.forEach(function (item) {
      var video = item.querySelector('.how-it-works-video');
      var soundBtn = item.querySelector('.how-video-sound-btn');

      if (observer) {
        observer.observe(item);
      } else {
        loadVideo(item);
      }

      if (soundBtn && video) {
        soundBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var willUnmute = video.muted;
          items.forEach(function (other) {
            if (other === item) return;
            var otherVideo = other.querySelector('.how-it-works-video');
            var otherBtn = other.querySelector('.how-video-sound-btn');
            if (otherVideo) otherVideo.muted = true;
            if (otherBtn) otherBtn.setAttribute('aria-pressed', 'false');
          });
          video.muted = !willUnmute;
          soundBtn.setAttribute('aria-pressed', willUnmute ? 'true' : 'false');
        });
      }

      item.addEventListener('click', function (e) {
        if (dragged) { dragged = false; return; }
        if (soundBtn && soundBtn.contains(e.target)) return;
        openModal(item);
      });
    });

    if (grid) {
      var isDown = false;
      var startX, scrollLeft;
      grid.addEventListener('mousedown', function (e) {
        isDown = true;
        dragged = false;
        grid.classList.add('is-dragging');
        startX = e.pageX - grid.offsetLeft;
        scrollLeft = grid.scrollLeft;
      });
      ['mouseleave', 'mouseup'].forEach(function (evt) {
        grid.addEventListener(evt, function () {
          isDown = false;
          grid.classList.remove('is-dragging');
        });
      });
      grid.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - grid.offsetLeft;
        var walk = (x - startX) * 1.2;
        if (Math.abs(walk) > 5) dragged = true;
        grid.scrollLeft = scrollLeft - walk;
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.how-it-works').forEach(initHowItWorks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
